// /* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getCitymapTable = params => {
  return axios.post(`${base}/citymap/query`, params)
}
export const getCitymapDetail = params => {
  return axios.get(`${base}/citymap/get_${params.id}`)
}
export const createCitymap = params => {
  return axios.post(`${base}/citymap/create`, params)
}
export const updateCitymap = params => {
  return axios.post(`${base}/citymap/edit_${params.id}`, params)
}
export const deleteCitymap = params => {
  return axios.post(`${base}/citymap/delete_${params.id}`, params)
}
export const getCitySalary = params => {
  return axios.get(`${base}/citymap/city_salary_${params.id}`)
}
export const updateCitySalary = params => {
  return axios.post(`${base}/citymap/save_city_salary_${params.id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/city-map/city-map.api.js